var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[(_vm.posts.length)?_c('posts-carousel',{staticClass:"posts-carousel",attrs:{"noTitle":true,"sectionTitle":"Peças de Marketing","posts":_vm.posts,"useCarousel":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }